import { render, staticRenderFns } from "./zarfalindibelgesi.vue?vue&type=template&id=289a747e&"
import script from "./zarfalindibelgesi.vue?vue&type=script&lang=js&"
export * from "./zarfalindibelgesi.vue?vue&type=script&lang=js&"
import style0 from "./zarfalindibelgesi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports